module.exports = __webpack_public_path__ + "static/img11-8a2426d4d067b4650aaa861569b219d4.jpg";